<template>
  <div class="database-tables-container">
    <div class="database-tables-header">
      <h2>数据库表管理</h2>
      <el-button type="primary" @click="openCreateDialog">创建表</el-button>
    </div>
    <el-card shadow="hover" class="database-tables-card">
      <el-table :data="tables" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="表名" width="200"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="viewTable(scope.row)">查看</el-button>
            <el-button type="warning" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 创建表对话框 -->
    <el-dialog title="创建表" :visible.sync="createDialogVisible" width="600px">
      <el-form ref="createForm" :model="form" :rules="rules" label-position="top">
        <el-form-item label="表名" prop="name">
          <el-input v-model="form.name" placeholder="请输入表名"></el-input>
        </el-form-item>
        <el-form-item label="表结构" prop="structure">
          <el-input v-model="form.structure" placeholder="请输入表结构 JSON" type="textarea" rows="8"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCreate" :loading="loading">创建</el-button>
      </div>
    </el-dialog>

    <!-- 编辑表对话框 -->
    <el-dialog title="编辑表" :visible.sync="editDialogVisible" width="600px">
      <el-form ref="editForm" :model="form" :rules="rules" label-position="top">
        <el-form-item label="表名" prop="name">
          <el-input v-model="form.name" placeholder="请输入表名"></el-input>
        </el-form-item>
        <el-form-item label="表结构" prop="structure">
          <el-input v-model="form.structure" placeholder="请输入表结构 JSON" type="textarea" rows="8"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdate" :loading="loading">更新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DatabaseTables',
  data() {
    return {
      databaseId: this.$route.params.databaseId,
      tables: [],
      createDialogVisible: false,
      editDialogVisible: false,
      loading: false,
      form: {
        id: null,
        name: '',
        structure: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入表名', trigger: 'blur' }
        ],
        structure: [
          { required: true, message: '请输入表结构', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchTables()
  },
  methods: {
    async fetchTables() {
      try {
        const response = await this.$axios.get(`/projects/${this.$route.query.projectId}/databases/${this.databaseId}/tables`)
        this.tables = response.data
      } catch (error) {
        this.$message.error('获取表列表失败')
      }
    },
    openCreateDialog() {
      this.form = {
        id: null,
        name: '',
        structure: ''
      }
      this.createDialogVisible = true
    },
    openEditDialog(table) {
      this.form = JSON.parse(JSON.stringify(table))
      this.editDialogVisible = true
    },
    async handleCreate() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            await this.$axios.post(`/projects/${this.$route.query.projectId}/databases/${this.databaseId}/tables`, this.form)
            this.$message.success('表创建成功')
            this.createDialogVisible = false
            this.fetchTables()
          } catch (error) {
            this.$message.error('表创建失败')
          } finally {
            this.loading = false
          }
        }
      })
    },
    async handleUpdate() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            await this.$axios.put(`/projects/${this.$route.query.projectId}/databases/${this.databaseId}/tables/${this.form.id}`, this.form)
            this.$message.success('表更新成功')
            this.editDialogVisible = false
            this.fetchTables()
          } catch (error) {
            this.$message.error('表更新失败')
          } finally {
            this.loading = false
          }
        }
      })
    },
    async handleDelete(table) {
      this.$confirm('确定要删除这个表吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$axios.delete(`/projects/${this.$route.query.projectId}/databases/${this.databaseId}/tables/${table.id}`)
          this.$message.success('表删除成功')
          this.fetchTables()
        } catch (error) {
          this.$message.error('表删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    viewTable() {
      this.$message.info('查看表详情功能开发中')
    }
  }
}
</script>

<style scoped>
.database-tables-container {
  width: 100%;
}

.database-tables-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.database-tables-header h2 {
  margin: 0;
  color: #303133;
}

.database-tables-card {
  margin-bottom: 20px;
}
</style>
